import { useEffect, useState, useCallback } from 'react';
import { cardsApi } from '../../apis/payment';
import { SavedCards } from '../../interfaces/payment';

export const useFetchCards = () => {
  const [cards, setSavedCards] = useState<SavedCards[]>([]);
  const [fetching, setFetching] = useState(false);
  const [error, setError] = useState(false);

  const fetchSavedCards = useCallback(async () => {
    try {
      setError(false);
      setFetching(true);
      const { data } = await cardsApi();
      setSavedCards(data);
      setFetching(false);
    } catch (error) {
      setError(true);
      setFetching(false);
    }
  }, [setError]);

  useEffect(() => {
    fetchSavedCards();
  }, [fetchSavedCards]);

  return { cards, error, fetching, fetchSavedCards };
};
